import { z } from 'zod';
import { PsychologicalQuestionResponseType } from '@/apolloClient.types';

export const scoringSchema = z.object({
    score: z.number(),
    label: z.string(),
});

export type ScoringSchema = z.infer<typeof scoringSchema>;

export const likertScaleResponseTypeSchema = z.object({
    responseType: z.nativeEnum(PsychologicalQuestionResponseType),
    scoring: z.array(scoringSchema),
});

export type LikertScaleResponseTypeSchema = z.infer<typeof likertScaleResponseTypeSchema>;

export const scaleLabelSchema = z.object({
    label: z.string(),
    description: z.string(),
    value: z.number(),
});

export const ratingScaleResponseTypeSchema = z.object({
    responseType: z.nativeEnum(PsychologicalQuestionResponseType),
    minimumValue: z.number(),
    maximumValue: z.number(),
    increment: z.number(),
    scaleLabels: z.array(scaleLabelSchema),
});

export type RatingScaleResponseTypeSchema = z.infer<typeof ratingScaleResponseTypeSchema>;

export const responseTypeSchema = z.object({
    likertScale: likertScaleResponseTypeSchema.optional(),
    ratingScale: ratingScaleResponseTypeSchema.optional(),
});

export type ResponseTypeSchema = z.infer<typeof responseTypeSchema>;

export const defaultLikertScaleResponseTypeOne: LikertScaleResponseTypeSchema = {
    responseType: PsychologicalQuestionResponseType.Likert,
    scoring: [
        {
            score: 1,
            label: 'Almost Never',
        },

        {
            score: 2,
            label: 'Rarely',
        },

        {
            score: 3,
            label: 'Once In A While',
        },
        {
            score: 4,
            label: 'Occasionally',
        },
        {
            score: 5,
            label: 'Usually',
        },
        {
            score: 6,
            label: 'Very Frequently',
        },
        {
            score: 7,
            label: 'Almost Always',
        },
    ],
};

export const defaultLikertScaleResponseTypeTwo: LikertScaleResponseTypeSchema = {
    responseType: PsychologicalQuestionResponseType.Likert,
    scoring: [
        {
            score: 1,
            label: 'Strongly Disagree',
        },
        {
            score: 2,
            label: 'Disagree',
        },
        {
            score: 3,
            label: 'Neutral',
        },

        {
            score: 4,
            label: 'Agree',
        },
        {
            score: 5,
            label: 'Strongly Agree',
        },
    ],
};

export const defaultRatingScaleResponseType: RatingScaleResponseTypeSchema = {
    responseType: PsychologicalQuestionResponseType.Rating,
    minimumValue: 1,
    maximumValue: 100,
    increment: 10,
    scaleLabels: [
        {
            label: 'Almost Never',
            description: 'Totally spent, nothing in reserve',
            value: 10,
        },
        {
            label: 'Medium',
            description: 'Somewhat depleted, but something in reserve',
            value: 50,
        },

        {
            label: 'High',
            description: 'Fully ready with plenty in reserve',
            value: 100,
        },
    ],
};
